import React, { Fragment, useEffect, useState } from "react";
import { CCollapse, CLink } from "@coreui/react";
import axios from "axios";
import config from "../../config/config";
import { toastSuccess, toastError } from "../../common/Toast";
import { ERROR_MESSAGE, SUCCESS_MESSAGE } from "../../common/Constant";

function CommonConfiguration({
  visibleCommonChange,
  searchQuery,
  dynamicModule,
}) {
  const [visiblePopup, setVisiblePopup] = useState(false);
  const [popup, setPopup] = useState(visibleCommonChange);
  const [commonConfig, setCommonConfig] = useState(0);
  const token = localStorage.getItem("Token");

  // For FormValues
  const [formValues, setFormValues] = useState({
    Categories: 0,
    ClientDetails: 0,
    FeaturedProducts: 0,
    HidePriceUntilLogin: 0,
    PriceShownAccordingToRole: 0,
    Testimonial: 0,
    NewArrivals: 0,
    TheMostPopular: 0,
    Clearance: 0,
    HotSelling: 0,
    DealOfDay: 0,
    HideShowNewArrivalsTagsAuto: 0,
    HideShowFeaturedProductTagsAuto: 0,
    HideShowClearanceTagsAuto: 0,
    HideShowMostPopularTagsAuto: 0,
    HideShowHotSellingTagsAuto: 0,
    HideGridBanner: 0,
    HideFooterCategories: 0,
  });
  // For FormValues

  const handleChange = (event, fieldName) => {
    const checked = event.target.checked ? "1" : "0";

    // find the index of the item to update
    const index = commonConfig.findIndex(
      (item) => item.CommonConfigKey === fieldName
    );

    // create a new item with the updated value
    const updatedItem = {
      CommonConfigKey: fieldName,
      CommonConfigValue: checked,
    };

    // create a copy of the current state array
    const updatedConfig = [...commonConfig];

    // replace the item at the specified index with the new item
    updatedConfig[index] = updatedItem;

    // update the state with the new array
    setCommonConfig(updatedConfig);
  };

  //Array of names

  //matchSearchQuery
  const matchesSearchQuery =
    commonConfig &&
    commonConfig.filter((el) => {
      return el.CommonConfigKey.toLowerCase().includes(
        searchQuery.toLowerCase()
      );
    });

  useEffect(() => {
    axios
      .get(
        `${config.ecommconfigBaseUrl}/ecomconfig/commonconfigvalues?configtype=CommonConfig&from=${dynamicModule}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        setCommonConfig(res.data.ResponseData);
      })
      .catch((err) => {});
  }, [dynamicModule]);

  const handleSubmit = (e) => {
    e.preventDefault();

    try {
      const data = {
        Categories: commonConfig.find(
          (el) => el?.CommonConfigKey === "Categories"
        )?.CommonConfigValue,
        Brands: commonConfig.find((el) => el?.CommonConfigKey === "Brands")
          ?.CommonConfigValue,
        Clearance: commonConfig.find((el) => el?.CommonConfigKey === "Clearance")
          ?.CommonConfigValue,
        ClientDetails: commonConfig.find(
          (el) => el?.CommonConfigKey === "ClientDetails"
        )?.CommonConfigValue,
        FeaturedProducts: commonConfig.find(
          (el) => el?.CommonConfigKey === "FeaturedProducts"
        )?.CommonConfigValue,
        HidePriceUntilLogin: commonConfig.find(
          (el) => el?.CommonConfigKey === "HidePriceUntilLogin"
        )?.CommonConfigValue,
        HotSelling: commonConfig.find(
          (el) => el?.CommonConfigKey === "HotSelling"
        )?.CommonConfigValue,
        NewArrivals: commonConfig.find(
          (el) => el?.CommonConfigKey === "NewArrivals"
        )?.CommonConfigValue,
        PriceShownAccordingToRole: commonConfig.find(
          (el) => el?.CommonConfigKey === "PriceShownAccordingToRole"
        )?.CommonConfigValue,
        Testimonial: commonConfig.find(
          (el) => el?.CommonConfigKey === "Testimonial"
        )?.CommonConfigValue,
        TheMostPopular: commonConfig.find(
          (el) => el?.CommonConfigKey === "TheMostPopular"
        )?.CommonConfigValue,
        EnableLendingPage: commonConfig.find(
          (el) => el?.CommonConfigKey === "EnableLendingPage"
        )?.CommonConfigValue,
        DealOfDay: commonConfig.find((el) => el?.CommonConfigKey === "DealOfDay")
          ?.CommonConfigValue,
        HideShowHotSellingTagsAuto: commonConfig.find(
          (el) => el?.CommonConfigKey === "Hide Show Hot Selling Tags Auto"
        )?.CommonConfigValue,
        HideShowMostPopularTagsAuto: commonConfig.find(
          (el) => el?.CommonConfigKey === "Hide Show Most Popular Tags Auto"
        )?.CommonConfigValue,
        HideShowClearanceTagsAuto: commonConfig.find(
          (el) => el?.CommonConfigKey === "Hide Show Clearance Tags Auto"
        )?.CommonConfigValue,
        HideShowFeaturedProductTagsAuto: commonConfig.find(
          (el) => el?.CommonConfigKey === "Hide Show Featured Product Tags Auto"
        )?.CommonConfigValue,
        HideShowNewArrivalsTagsAuto: commonConfig.find(
          (el) => el?.CommonConfigKey === "Hide Show New Arrivals Tags Auto"
        )?.CommonConfigValue,
        HideGridBanner: commonConfig?.find(
          (el) => el?.CommonConfigKey === "HideGridBanner"
        )?.CommonConfigValue,
        HideFooterCategories: commonConfig?.find(
          (el) => el?.CommonConfigKey === "HideFooterCategories"
        )?.CommonConfigValue,
        EnableWishlist: commonConfig?.find(
          (el) => el?.CommonConfigKey === "EnableWishlist"
        )?.CommonConfigValue,
        from: dynamicModule,
      };

      // return true;
      console.log("findbug", e);
      axios
        .post(
          `${config.ecommconfigBaseUrl}/ecomconfig/commonconfigupsert`,
          data,
          {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              "Access-Control-Allow-Origin": "*",
              Authorization: token,
            },
          }
        )
        .then((res) => {
          if (res.data.ResponseCode === "SUCCESS") {
            toastSuccess(SUCCESS_MESSAGE);
            // navigate("/suppliers");
          } else if (
            res.data.ResponseCode === "ERROR" &&
            res.data.ResponseID === -1
          ) {
            // toastError("Email" + ALREADY_EXIST);
          } else {
            toastError(ERROR_MESSAGE);
          }
          // setLoading(false);
        })
        .catch((error) => {
          // setLoading(false);
        });
    } catch (error) {
      console.log(error, "findbug");
    }
  };
  //handleSubmit

  return (
    <Fragment>
      {matchesSearchQuery.length === commonConfig.length ? (
        <div className="card">
          <div className="card-header">
            <h5 className="card-title">
              <CLink
                className="link"
                onClick={() => {
                  setVisiblePopup(!visiblePopup);
                  setPopup(!!popup);
                }}
              >
                Common Configuration
              </CLink>
            </h5>
          </div>
          <CCollapse visible={visiblePopup || visibleCommonChange}>
            <div className="card-body">
              <form onSubmit={handleSubmit}>
                <div className="d-flex flex-wrap gap-2 mt-3">
                  {commonConfig &&
                    commonConfig.map((item, index) => (
                      <div
                        key={index}
                        className="d-flex align-items-center border rounded px-3 py-2 col-xxl-3 col-xl-3 col-lg-2 col-md-2 col-sm-3 col-12"
                        // style={{
                        //   minWidth: "220px",
                        //   fontSize: "14px",
                        //   backgroundColor: "#fff",
                        // }}
                      >
                        <span style={{padding:"4px", fontSize:"14px"}} className="me-auto">{item.CommonConfigKey}</span>
                        <div className="form-check form-switch m-0">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            id={`toggle-${item.CommonConfigKey}`}
                            name={item.CommonConfigKey}
                            checked={item.CommonConfigValue === "1"}
                            onChange={(event) =>
                              handleChange(event, item.CommonConfigKey)
                            }
                          />
                        </div>
                      </div>
                    ))}
                </div>

                {/* <div className="card-footer"> */}
                <button className="btn btn-primary mt-3" type="submit">
                  Submit
                </button>
                {/* </div> */}
              </form>
            </div>
          </CCollapse>
        </div>
      ) : (
        matchesSearchQuery.length !== 0 && (
          <div className="card">
            <div className="card-header">
              <h5 className="card-title">
                <CLink
                  onClick={() => {
                    setVisiblePopup(!visiblePopup);
                    setPopup(!!popup);
                  }}
                >
                  Common Configuration
                </CLink>
              </h5>
            </div>
            <CCollapse visible={visiblePopup || visibleCommonChange}>
              <div className="card-body">
                <form onSubmit={handleSubmit}>
                  {matchesSearchQuery &&
                    matchesSearchQuery.map((item, index) => (
                      <div className="col-md-6 mt-3">
                        <div className="row">
                          <div className="col-md-5">
                            <h6 style={{ fontSize: "15px" }}>
                              {item.CommonConfigKey}
                            </h6>
                          </div>
                          <div className="col-md-7 mt-1">
                            <div class="form-check form-switch">
                              <input
                                class="form-check-input"
                                type="checkbox"
                                // id="flexSwitchCheckDefault"
                                id={`toggle-${item.CommonConfigKey}`}
                                name={item.CommonConfigKey}
                                // value={item.CommonConfigValue}
                                checked={item.CommonConfigValue === "1"}
                                onChange={(event) =>
                                  handleChange(event, item.CommonConfigKey)
                                }
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  {/* <div className="card-footer"> */}
                  <button className="btn btn-primary mt-3" type="submit">
                    Submit
                  </button>
                  {/* </div> */}
                </form>
              </div>
            </CCollapse>
          </div>
        )
      )}
    </Fragment>
  );
}

export default CommonConfiguration;
